import { render, staticRenderFns } from "./PatientInfo.vue?vue&type=template&id=a33f706c&scoped=true&"
import script from "./PatientInfo.vue?vue&type=script&lang=js&"
export * from "./PatientInfo.vue?vue&type=script&lang=js&"
import style0 from "./PatientInfo.vue?vue&type=style&index=0&id=a33f706c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33f706c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a33f706c')) {
      api.createRecord('a33f706c', component.options)
    } else {
      api.reload('a33f706c', component.options)
    }
    module.hot.accept("./PatientInfo.vue?vue&type=template&id=a33f706c&scoped=true&", function () {
      api.rerender('a33f706c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clinic/components/Management/components/PatientInfo.vue"
export default component.exports